"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var constants_1 = require("../../../../../constants");
var OvmZadavateleForm_1 = __importDefault(require("../../DruhyOsobField/components/OvmZadavateleForm"));
var PridatOvmZadavatele = function (_a) {
    var addZadavatel = _a.addZadavatel, isPosudek = _a.isPosudek;
    var handleAdd = function (item, form) {
        var newvalue = __assign(__assign({}, item), { typOsoby: isPosudek ? constants_1.PosudkyTypOsoby.OVM : constants_1.UkonyTypOsoby.OVM, adresaPobytu: item.adresa, adresaSidla: item.adresa });
        addZadavatel(newvalue, form);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(OvmZadavateleForm_1.default, { onSubmit: handleAdd, labels: {
                search: 'Zadejte IČO nebo ID datové schránky',
                submit: 'PŘIDAT ZADAVATELE',
            }, isPosudek: isPosudek })));
};
exports.default = PridatOvmZadavatele;
